import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.bereich-detail-admin';
import * as api from '../../../clients/displaysteuerung';

@Injectable()
export class DisplaysteuerungBereichDetailAdminEffects {

    BereichDetailAdmin$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_BEREICH_DETAIL_ADMIN),
        mergeMap((x: ac.GetBereichDetailAdminAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getBereichDetailAdmin(x.bereich_id).pipe(
                map((result: any) => {
                    return new ac.GetBereichDetailAdminErfolgreichAction(result, x.bereich_id, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetBereichDetailAdminFehlerAction(error, x.bereich_id, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.VerwaltenQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.VerwaltenQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.VerwaltenQueryService);
        }
        return this.service;
    }
}
